const STATUS_COLORS: Record<string, string> = {
  NEW: "var(--panel-status-new)",
  INPR: "var(--panel-status-inpr)",
  RVEW: "var(--panel-status-rvew)",
  COMP: "var(--panel-status-comp)",
  HOLD: "var(--panel-status-hold)",
  CANC: "var(--panel-status-hold)",
};

interface StatusBadgeProps {
  statusCode: string | null | undefined;
  statusDescription?: string | null;
}

export function StatusBadge({
  statusCode,
  statusDescription,
}: StatusBadgeProps) {
  const code = statusCode ?? "";
  const color = STATUS_COLORS[code] ?? "var(--panel-status-default)";
  const label = statusDescription ?? code;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "1px 6px",
        borderRadius: "var(--panel-radius)",
        fontSize: "var(--panel-font-size-xs)",
        fontWeight: 600,
        letterSpacing: "0.03em",
        textTransform: "uppercase",
        background: color,
        color: "var(--panel-accent-text)",
        lineHeight: 1.6,
      }}
    >
      {label}
    </span>
  );
}
